import { loadState, saveState } from "../../stores/store";  
import { LogoutOutlined, UserOutlined, ProfileOutlined } from '@ant-design/icons';  
import { Avatar, Typography, Popover, Space, Button } from 'antd';  
import { useNavigate } from "react-router-dom";  
import axios from "axios";  
const { Text } = Typography;  
  
// Helper  
function arrayBufferToBase64(buffer) {  
  // Accepts Array or Uint8Array  
  let binary = '';  
  const bytes = new Uint8Array(buffer);  
  const len = bytes.byteLength;  
  for (let i = 0; i < len; i++) {  
    binary += String.fromCharCode(bytes[i]);  
  }  
  return window.btoa(binary);  
}  
  
const UserProfilePopup = ({ contestant }) => {  
  const navigate = useNavigate();  
  
  const getInitials = (name) => {  
    let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');  
    let initials = [...name.matchAll(rgx)] || [];  
    initials = (  
      (initials.shift()?.[1] || '') +  
      (initials.pop()?.[1] || '')  
    ).toUpperCase();  
    return initials;  
  };  
  
  function getProfilePhotoSrc() {  
    if (  
      contestant &&  
      contestant.profilePhoto &&  
      contestant.profilePhoto.img &&  
      contestant.profilePhoto.img.data &&  
      contestant.profilePhoto.img.contentType  
    ) {  
      let base64;  
      // data is sometimes Array (bson), sometimes normal base64  
      if (Array.isArray(contestant.profilePhoto.img.data)) {  
        base64 = arrayBufferToBase64(contestant.profilePhoto.img.data);  
      } else if (contestant.profilePhoto.img.data?.type === 'Buffer' && Array.isArray(contestant.profilePhoto.img.data.data)) {  
        base64 = arrayBufferToBase64(contestant.profilePhoto.img.data.data);  
      } else if (typeof contestant.profilePhoto.img.data === 'string') {  
        // already base64  
        base64 = contestant.profilePhoto.img.data;  
      } else {  
        try {  
          base64 = arrayBufferToBase64(contestant.profilePhoto.img.data);  
        } catch {  
          base64 = undefined;  
        }  
      }  
      return `data:${contestant.profilePhoto.img.contentType};base64,${base64}`;  
    }  
    return undefined;  
  }  
  
  const logoutUser = async () => {  
    try {  
      axios.defaults.headers.common["Authorization"] = "";  
      saveState(null);  
      navigate("/", { replace: true });  
    } catch (error) {  
      console.error("Logout error:", error);  
    }  
  };  
  
  const viewProfile = async () => {  
    try {  
      navigate("/profile", { replace: true });  
    } catch (error) {  
      console.error(error);  
    }  
  };  
  
  const state = loadState();  
  
  return (  
    <Popover  
      arrow  
      placement="bottomRight"  
      trigger='click'  
      title={"User profile"}  
      content={(  
        <Space className="user-profile-popup" size="middle" direction="vertical">  
          <Space size="middle">  
            <Avatar  
              draggable={true}  
              size={100}  
              style={{ backgroundColor: '#1271dd', fontSize: 40, marginBottom: '16px' }}  
              src={getProfilePhotoSrc()}  
            >  
              {getInitials(`${state.user.first_name} ${state.user.last_name}`)}  
            </Avatar>  
            <div className="user-profile-popup-details">  
              <Text strong style={{ fontSize: '18px' }}>{`${state.user.first_name} ${state.user.last_name}`}</Text>  
              <Text type="secondary">{state.user.email}</Text>  
            </div>  
          </Space>  
          {state.user.role === 'contestant' && (  
            <Button block icon={<ProfileOutlined />} onClick={viewProfile}>View Profile</Button>  
          )}  
          <Button block icon={<LogoutOutlined />} onClick={logoutUser}>Logout</Button>  
        </Space>  
      )}  
    >  
      <Space align="center" style={{ cursor: 'pointer'}}>  
        <Avatar  
          draggable={true}  
          size={35}  
          style={{ backgroundColor: '#1271dd', fontSize: 14 }}  
          src={getProfilePhotoSrc()}  
        >  
          {getInitials(`${state.user.first_name} ${state.user.last_name}`)}  
        </Avatar>  
        <div className="user-profile-popup-details user-profile-popup-details-header">  
          <Text strong style={{ fontSize: '14px', lineHeight: '14px', marginBottom: '5px' }}>{`${state.user.first_name} ${state.user.last_name}`}</Text>  
          <Text type="secondary" style={{ lineHeight: '14px'}}>{state.user.role}</Text>  
        </div>  
      </Space>  
    </Popover>  
  )  
};  
export default UserProfilePopup;  